<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">主网快速入门</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">区块链浏览器</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">Remix</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(11)" class="s2"><a :class="{active:flag==11}" href="#box11">Consensus</a></p>
            <p @click="activeted(12)" class="s2"><a :class="{active:flag==12}" href="#box12">PlatformVM</a></p>
            <p @click="activeted(13)" class="s2"><a :class="{active:flag==13}" href="#box13">Coreth</a></p>
          </div> -->
        </div>
      </div>
      <div id="box1" class="p1">主网快速入门</div>
      <div class="p4">1. 为 FaxChain 主网配置 Metamask </div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>网络名称：FaxChain主网</li>
          <li>RPC 网址：http://api.faxchain.org</li>
          <li>链号：778777</li>
          <li>货币符号：FAX</li>
          <li>区块浏览器 URL：http://faxscan.org/</li>
        </ul>
      </div>
      <div class="p3">
        <img style="width:100%;height:100%" src="@/assets/img/faxchain.png" alt="">
      </div>
      <div class="p4">2. 创建新账户或导入现有账户</div>
      <div class="p3">
        <img style="width:100%;height:100%" src="@/assets/img/creatAccount.png" alt="">
      </div>
      <div class="p4">3. 为FaxChain主网配置ETHEREUM WEBSOCKET</div>
      <div class="p3">请参考详细配置</div>
      <div id="box2" class="p2">区块链浏览器</div>
      <div class="p3"><a href="http://faxscan.org/">Faxchain主网浏览器</a> </div>
      <div id="box3" class="p2">Remix</div>
      <div class="p3">设置 Remix FaxChain 主网开发环境。Remix 是用于 Solidity 智能合约的浏览器内 IDE。在本指南中，我们将学习如何通过 Remix 将合约部署到正在运行的 FaxChain 主网并与之交互。</div>
      <div class="p4">1. 连接FaxChain账号到Remix </div>
      <div class="p3">文件资源管理器中有一些合同。选择这些合同中的任何一个。在本例中，我们使用 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Storage.sol</span> . 在最左边的栏中，选择 Solidity Compiler 并编译合约。</div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/sol1.png" alt=""></div>
      <div class="p3">接下来，选择选项。选择作为环境。这将打开一个元掩码弹出窗口，供您确认将元掩码连接到 Remix。点击确认。 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Deploy and Runinjected web3</span> </div>
      <div class="p3">您应该会在左侧面板中看到您的帐户。</div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/sol2.png" alt=""></div>
      <div class="p4">2. 部署和交互</div>
      <div class="p3">现在您的帐户已连接，您可以部署合同。按部署按钮。将出现一个元掩码弹出窗口，要求您确认。</div>
      <div class="p3">确认交易成功部署合约后，您将看到它显示在左侧的 Deployed Contracts 部分，以及 Remix 控制台中的绿色复选标记显示交易详细信息。</div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/sol3.png" alt=""></div>
      <div class="p3">现在，您可以通过 Remix 与合约进行交互。对于 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Storage.sol</span> ，输入 1000 并单击store。这将打开一个 Metamask 弹出窗口，要求您确认。确认交易。然后，点击 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">retrieve</span> 获取数字，应该是 1000。</div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/sol4.png" alt=""></div>
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">主网快速入门</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">区块链浏览器</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">Remix</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(11)" class="s2"><a :class="{active:flag==11}" href="#box11">Consensus</a></p>
        <p @click="activeted(12)" class="s2"><a :class="{active:flag==12}" href="#box12">PlatformVM</a></p>
        <p @click="activeted(13)" class="s2"><a :class="{active:flag==13}" href="#box13">Coreth</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaxchainGo',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>